export enum ClientType {
  active = 0,
  approval = 1,
  inactive = 2,
}

export const ClientTypeUrl: any[] = [
  {
    link: '/clients/dashboard/active',
  },
  {
    link: '/clients/dashboard/approval',
  },
  {
    link: '/clients/dashboard/inactive',
  },
];

export const ClientTabs: any[] = ['Active Clients', 'Approval Needed', 'Inactive Clients'];
